import { addressSchema } from '@si/types';
import { get, objectToQueryParams } from '@si/utils';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from './queryKeys';

const responseSchema = z.object({
  addresses: z.array(addressSchema),
});

type Params = {
  enabled?: boolean;
  search: string;
};

export function useAddresses({ enabled = false, search }: Params) {
  const { data, error, isLoading } = useQuery({
    queryKey: queryKeys.getAddresses(search),
    queryFn: () =>
      get({
        url: `/addresses${objectToQueryParams({ search })}`,
        schema: responseSchema,
      }),
    enabled: enabled,
    placeholderData: keepPreviousData,
    retry: false,
  });

  return {
    addresses: data?.addresses || [],
    error,
    isLoading,
  };
}
